export { PackageDiningTemplate } from './PackageDiningTemplate';
export type {
  PackageDiningDateGroup,
  PackageDiningOption,
  PackageDiningSelectOption,
  PackageDiningTemplateLabels,
  PackageDiningTemplateProps,
} from './PackageDiningTemplate.types';
